<ng-container [caLocalizationScope]="localizationScope">
  <i
    [title]="
      excludedBy === 'User' && excludedFromMailUserId && lastModifiedDate
        ? ('excludedTitle' | caLocalize) +
          ' ' +
          (excludedFromMailUserId | caAccountUserFullName) +
          ' ' +
          ('onTitle' | caLocalize) +
          ' ' +
          (lastModifiedDate | caDate) +
          ' ' +
          ('atTitle' | caLocalize) +
          ' ' +
          (lastModifiedDate | caTime : { ignoreTimeZoneLabel: true })
        : ''
    "
    data-automation-id="excluded-from-mail-icon"
    class="f-i f-i-sm f-i-excluded-from-mail text-warning-700 align-bottom"
  ></i>
</ng-container>
